import React from 'react';

// helpers
import useTranslation from 'hooks/useTranslation';
import { styled } from 'styled-components';
import { colorsTheme } from 'resources/theme/styled/colors';

// components
import AmendAndWithdrawSection from '../AmendAndWithdrawSection';
import { Col, Divider, Row, SectionIntro, Text } from '@ui';

const Submitted = () => {
  const { t } = useTranslation(['onboarding', 'common']);

  return (
    <>
      <SectionIntro
        hideDivider
        titleColor={colorsTheme.colorWhite}
        title={t('intake_form.submitted.title')}
      />
      <StyledRow justify="space-between">
        <Col span={24}>
          <TextWithTopMargin>
            {t('intake_form.submitted.description_line_1')}
          </TextWithTopMargin>
        </Col>
        <Col span={24}>
          <Divider />
          <AmendAndWithdrawSection />
        </Col>
      </StyledRow>
    </>
  );
};

const TextWithTopMargin = styled(Text)`
  margin-top: ${({ theme }) => theme.marginMd};
`;

const StyledRow = styled(Row)`
  height: 100%;
`;

export default Submitted;
